import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  Box,
  Divider,
  Typography,
  Checkbox,
  Button,
  makeStyles,
} from "@material-ui/core";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import {
  GET_USER_DATA_BY_USERNAME,
} from "../../graphQL/register_qry";

import Header from "./Header";
import AlertDialog from "../../components/AlertDialog.js";

import { project_url } from "../../constants/Data";

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY,GET_STAFF_CLIENT_COMBINED_GROUPS_PERMISSIONS_QUERY } from "../../graphQL/user_qry";

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
  },
  container: {
    padding: theme.spacing(4),
    paddingTop: 0,
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
}));
const transformPermissions = (data) => {  
  return data.map((mod) => {
    
    return {
      ...mod,
      modulepage: mod.modulepage.map((page) => {

        
        const action = mod.groupModulepageAction.find(
          (a) => parseInt(a.modulepageId) === parseInt(page.modulepageId)
        );

        const parsePermissions = (names, values) => {
          if (!names) return [];
          return names.split("|").map((name) => ({
            permission: name.trim(),
            checked: values?.includes(`${name}:1`) || false,
          }));
        };

        return {
          ...page,
          permission: page.name,
          access: action?.access || false,
          common: parsePermissions(
            page.actionCommonName,
            action?.actionCommonPermission || ""
          ),
          additional: parsePermissions(
            page.actionAdditionalName,
            action?.actionAdditionalPermission || ""
          ),
        };
      }),
    };
  });
};
const extractCommonHeaders = (data) => {
  //removes repeated values automatically by using a Set
  const headerSet = new Set();
  data.forEach((mod) => {
    
    mod.modulepage.forEach((page) => {
      if (page.actionCommonName) {
        page.actionCommonName.split("|").forEach((perm) => {
          headerSet.add(perm.trim());
        });
      }
    });
  });
  return Array.from(headerSet);
};



const CombinedGroupPermission = () => {
  const classes = useStyles();

  const {  username } = useParams();

  const [loadData, setLoadData] = useState(false);

  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);

  const [commonHeaders,setCommonHeaders] = useState([]);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  //let selectedClientUuid = "";
  //if (localStorage.getItem("selectedClientUuid")) 
    //selectedClientUuid = localStorage.getItem("selectedClientUuid");

  let clientName = "";
  if (localStorage.getItem("clientName")) 
    clientName = localStorage.getItem("clientName");

  const [permissionAccess, setPermissionAccess] = useState(true);

  
  const [modulesPermissions, setModulesPermissions] = useState([]); 

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Staff",
              modulepageName: "List",     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let additionalActions = accessData.staffModuleAccess.additionalActions.split("|");
      
      
      if(additionalActions.find(a => a == "Groups")){
        setPermissionAccess(true);}
      else { setPermissionAccess(false);}


      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

   const [alertMsg, setAlertMsg] = useState([]);

  const [getUserDataByUserName] = useManualQuery(GET_USER_DATA_BY_USERNAME, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    (() => getUserData())();
  }, [username]);
  
  const getUserData = async () => {
    // Get user information
    const {
      loading: userDataLoading,
      error: userDataError,
      data: userData,
    } = await getUserDataByUserName({
      variables: { username: username },
    });

    if (userData && !userData.getUserDataByUsername) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (
      userData &&
      userData.getUserDataByUsername &&
      userData.getUserDataByUsername == null
    ) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (!userDataLoading && userData && userData.getUserDataByUsername) {
      setLoadContent(true);
      setFirstName(userData.getUserDataByUsername.firstName);
      setLastName(userData.getUserDataByUsername.lastName);
      setLoadData(true);
      console.log("load page");
    }

    if (
      userDataError &&
      userDataError.graphQLErrors &&
      userDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };

  const [getGroupPermissionsData] = useManualQuery(GET_STAFF_CLIENT_COMBINED_GROUPS_PERMISSIONS_QUERY, {
    fetchPolicy: "network-only",
  });

  const getGroupPermissions = async () => {    
    
    if (username) {
      // Get group permission information
      const {
        loading: groupPermissionDataLoading,
        error: groupPermissionDataError,
        data: groupPermissionData,
      } = await getGroupPermissionsData({
        variables: { username: username,
                     tenantId: parseInt(tenantId),
                     clientId: parseInt(clientId) },
      });

      

      if (!groupPermissionDataLoading && groupPermissionData && groupPermissionData.getStaffClientCombinedGroupsPermissions) { 
            
            setModulesPermissions(transformPermissions(groupPermissionData.getStaffClientCombinedGroupsPermissions));
            setCommonHeaders(extractCommonHeaders(groupPermissionData.getStaffClientCombinedGroupsPermissions));
                
          }
      if (
        groupPermissionDataError &&
        groupPermissionDataError.graphQLErrors &&
        groupPermissionDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };

  useEffect(() => {

    (() => getGroupPermissions())();
  }, []);  

  const maxAdditional = Math.max(
    ...modulesPermissions.flatMap((mod) =>
      mod.modulepage.map((p) => p.additional.length)
    )
  );

  
  const flatRows = modulesPermissions.flatMap((mod) =>    
    mod.modulepage.map((p, index) => ({
      moduleId: mod.moduleId,
      moduleName: mod.name,
      page: p,
      pageCount: mod.modulepage.length,
      isFirstPage: index === 0,
    }))

  );

     
  const cellStyle = { borderRight: "1px solid #ccc" };
  const cellStyleAdditional = {
    borderRight: "1px solid #ccc",
    textAlign: "left",
  };

  
  if (loadContent)
  if (permissionAccess)

  return (
    <div className={classes.root}>
      <Header
          breadcrumbs={[
            { label: firstName + " " + lastName, link: null },
            { label: "Staff Groups", link: `${project_url}/staff/${username}/groups/` },
            { label: "Combined Group Permissions", link: null }
          ]}
        />
      <div className={classes.container}>
        <Box mt={2} mb={2} textAlign="center">
          <Typography variant="body1" style={{ fontWeight: 600 }}>
            Combined Group Permissions
          </Typography>
        </Box>
        <Divider />
          <Box pt={2} style={{display: "flex", flexDirection: "row", alignItems: "center",}}>
            <Typography style={{ paddingRight: 5 }} variant="h3">
              <strong>Staff:</strong> {firstName} {lastName}
            </Typography>
          </Box>
          <Box pt={2} style={{display: "flex", flexDirection: "row", alignItems: "center",}}>
            <Typography style={{ paddingRight: 5 }} variant="h3">
              <strong>Client:</strong> {clientName}
            </Typography>
          </Box>
          <Box pt={2} style={{display: "flex", flexDirection: "row", alignItems: "center",}}>
            <Typography style={{ paddingRight: 5 }} variant="h3">
              <strong>Group:</strong> Combined
            </Typography>
            <Box pl={1}>
            </Box>
          </Box>
        <Box pb={4} />

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{ border: "1px solid #e0e0e0", boxShadow: "none" }}
        >
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell rowSpan={2} sx={cellStyle} align="center">
                  <strong>Module</strong>
                </TableCell>
                <TableCell rowSpan={2} sx={cellStyle} align="center">
                  <strong>Page</strong>
                </TableCell>
                <TableCell
                  colSpan={commonHeaders.length}
                  align="center"
                  sx={cellStyle}
                >
                  <strong>Common Permissions</strong>
                </TableCell>
                <TableCell rowSpan={2} align="center">
                  <strong>Additional Permissions</strong>
                </TableCell>
              </TableRow>
              <TableRow>
                {commonHeaders.map((perm) => (
                  <TableCell key={perm} align="center" sx={cellStyle}>
                    <strong>{perm}</strong>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {flatRows.map((row) => (
                <TableRow key={`${row.moduleId}-${row.page.modulepageId}`}>
                  {row.isFirstPage && (
                    <TableCell rowSpan={row.pageCount} sx={cellStyle}>
                      {row.moduleName}
                    </TableCell>
                  )}
                  <TableCell sx={cellStyle}>
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        size="small"
                        checked={row.page.access}
                        disabled={true}
                      />
                      {row.page.permission}
                    </Box>
                  </TableCell>

                  {commonHeaders.map((perm) => (
                    <TableCell key={perm} align="center" sx={cellStyle}>                      
                      <Checkbox
                        size="small"
                        disabled={true}
                        checked={
                          row.page.common.find((c) => c.permission === perm)
                            ?.checked || false
                        }
                        
                      />
                    </TableCell>
                  ))}
                  <TableCell align="center">
                    {row.page.additional.length === 0 ? (
                      <>None</>
                    ) : (
                      row.page.additional.map((perm) => (
                        <Box
                          key={perm.permission}
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            size="small"
                            disabled={true}
                            checked={perm.checked}
                            
                          />
                          {perm.permission}
                        </Box>
                      ))
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box mt={4} textAlign="center">
          <Button
            variant="contained"
            className={classes.buttonStyle}
            onClick={() => navigate(`${project_url}/staff/${username}/groups/`)}
          >
            OK
          </Button>
          
        </Box>

        {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
                alertMsg.title === "Success" && navigate(`${project_url}/groups`);
              }}
            />
          )}

      </div>
    </div>
  );

  else
    return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
};

export default CombinedGroupPermission;
